import React from 'react'
import BannerComponent from '../Common-Component/BannerComponent/BannerComponent'
import FAQ_Tabs from './FAQ_Tabs/FAQ_Tabs'
import './FAQ.css'
import Help from './Help/Help'

const FAQ = () => {
    return (
        <section className='FAQ AboutUs'>
            <BannerComponent img="\assets\Images\FAQ\banner.png" title="FAQ" />

            <div className='container'>
                <div className='below_banner_section'>
                    <FAQ_Tabs />
                </div>

                <Help />

            </div>
        </section>
    )
}

export default FAQ
